import Timeline from './Timeline';
export default Timeline;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/timeline/index.js
// module id = 762
// module chunks = 0